import { CircularProgress, makeStyles, Theme } from "@material-ui/core";
import { useMemo } from "react";

interface Props {
  ringNumber: number;
  wrapperSize: number;
  color: string;
  value?: number | null;
}

const useStyles = makeStyles<Theme, Props>((theme: Theme) => ({
  secondaryColor: () => ({
    color: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  }),
  position: ({ ringNumber }) => ({
    margin: `${(ringNumber - 1) * 10}px 0 0 ${(ringNumber - 1) * 10}px`,
  }),
  circle: () => ({
    strokeWidth: "1",
    strokeLinecap: "round",
  }),
  primaryColor: ({ color }) => ({
    color: color,
  }),
}));

export const StackedCircularIndicator = (props: Props) => {
  const { ringNumber, wrapperSize, value } = props;
  const classes = useStyles(props);
  const size = useMemo(() => {
    return wrapperSize - (ringNumber - 1) * 20;
  }, [wrapperSize, ringNumber]);

  return (
    <div className="stacked-circular-indicator">
      <CircularProgress
        className={classes.position}
        variant="determinate"
        classes={{
          colorPrimary: classes.secondaryColor,
          circle: classes.circle,
        }}
        size={size}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        className={`widget-circular ${classes.position}`}
        classes={{
          colorPrimary: classes.primaryColor,
          circle: classes.circle,
        }}
        size={size}
        value={value ?? undefined}
        style={{ transform: "rotate(90deg)" }}
      />
    </div>
  );
};
